<div *ngIf="_tabOpen">
    <ng-container>
        <ng-content></ng-content>
    </ng-container>
</div>